import component from './VueDatepickerLocal.vue'
function install (Vue) {
  Vue.component(component.name, component)
}
component.install = install
if (typeof window !== 'undefined' && window.Vue) {
  install(window.Vue)
}
export default component



//////////////////
// WEBPACK FOOTER
// ./~/vue-datepicker-local/src/index.js
// module id = 364
// module chunks = 7